import { throwError, Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../environments/environment';
import * as _ from 'lodash';
import { BaseService } from './baseService';

@Injectable({
  providedIn: 'root'
})
export class ApiService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  private formatErrors(error: any) {
    this.http.post(`${environment.api_url}/log/error`, { href: document.location.href, error }).subscribe();
    return throwError(error);
  }

  public get(path: string, headers?: { [header: string]: string | string[] }, params?: any): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { headers, params }).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      })
    );
  }

  downloadFile(path: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      })
    );
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(`${environment.api_url}${path}`, JSON.stringify(body)).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      })
    );
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(`${environment.api_url}${path}`, JSON.stringify(body)).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      }),
      map((res: any) => res)
    );
  }

  post(path: string, body: Object = {}, headers: { [header: string]: string | string[] } = {}): Observable<any> {
    return this.http
      .post(`${environment.api_url}${path}`, JSON.stringify(body), {
        headers
      })
      .pipe(
        catchError((err) => {
          return this.formatErrors(err);
        })
      );
  }

  delete(path: string): Observable<any> {
    return this.http.delete(`${environment.api_url}${path}`).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      })
    );
  }

  postFormData(path: string, formData: any): Observable<any> {
    return this.http
      .post(`${environment.api_url}${path}`, formData, { headers: new HttpHeaders({ ignore: 'true' }) })
      .pipe(
        catchError((err) => {
          return this.formatErrors(err);
        })
      );
  }

  getImage(path: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { responseType: 'blob' }).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      }),
      map((res: Blob) => {
        if (res) {
          return res;
        } else {
          return '';
        }
      })
    );
  }

  getFile(path: string, name?: string, type?: string): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { responseType: 'arraybuffer' }).pipe(
      catchError((err) => {
        return this.formatErrors(err);
      }),
      map((res: ArrayBuffer) => {
        if (res) {
          return new File([res], name, { type: type });
        } else {
          return '';
        }
      })
    );
  }

  download(path: string, body?: any): Observable<Blob> {
    return (
      body
        ? this.http.post(`${environment.api_url}${path}`, body, { responseType: 'blob' })
        : this.http.get(`${environment.api_url}${path}`, { responseType: 'blob' })
    ).pipe(catchError((err) => this.formatErrors(err)));
  }

  downloadAndOpen(path: string, name: string, body?: any) {
    return this.download(path, body).subscribe((blob) => {
      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = name;
      link.click();
    });
  }
}
